import React from 'react';
import { graphql, compose } from 'react-apollo';
import AllTimeRevivalDatesWidget from '../../../../widgets/allTime/allTimeRevivalDatesWidget';
import { getGuestCardsActivitiesStatistics } from './queries/queries';
import GuestCardActivitiesWidget from '../../common/widgets/guestCardActivities';
import DataProcessor from '../../common/dataProcessors/guestCardActivitiesDataProcessor';
import { IaksByTypeDistribution } from '../../common/charts/iaksByTypeDistribution';
import { IaksByDayDistribution } from '../../common/charts/iaksByDayDistribution';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class GuestCardActivities extends AllTimeRevivalDatesWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.allTime.guestCardActivities;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'all time');
  }

  render() {
    return (
      <GuestCardActivitiesWidget data={this.dataProcessor.data} title="All Time Guest Card Activities"
                                 loading={this.props.data.loading} comment={this.comment}>
        <IaksByDayDistribution data={this.dataProcessor.byDayChartData}
                               barTooltip={this.dataProcessor.byDayBarTooltip}
                               tickValues={this.tickValues}
                               tickFormat={this.tickFormat}
                               showStroke={true}/>
        <IaksByTypeDistribution data={this.dataProcessor.byTypeChartData} />
      </GuestCardActivitiesWidget>
    );
  }
}

export default compose(
  graphql(getGuestCardsActivitiesStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(GuestCardActivities);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/guestCardActivities.js